import React from 'react';
import NavigateStatistic from "@containers/statistic/navigateStatistic/NavigateStatistic";
import {sx} from './sx'
import Box from '@mui/material/Box';

const Statistic = () => {

    return (
        <Box
            sx={sx.root}
        >
            <NavigateStatistic/>
        </Box>
    )

};

export default Statistic;